export const TooltipsLoomIds = {
  'CHANGE_IMAGE_MODAL.TITLE': '9bccf863ce574484a95424df960c1470',
  'CLUB_ROSTER.ADD_PLAYERS': '9bccf863ce574484a95424df960c1470',
  'CLUB_SETTINGS.ABOUT_CLUB': '9bccf863ce574484a95424df960c1470',
  'CLUB_SETTINGS.MEMBERSHIP_FEES': '9bccf863ce574484a95424df960c1470',
  'ENTRY_FEES.COUPONS': '9bccf863ce574484a95424df960c1470',
  'ENTRY_FEES.DESCRIPTION': '9bccf863ce574484a95424df960c1470',
  'ENTRY_FEES.EXTRAS': '9bccf863ce574484a95424df960c1470',
  'ENTRY_FEES.PAYMENT_THROUGH_WAGL': '9bccf863ce574484a95424df960c1470',
  'EVENT_SETUP.EVENT_INFORMATION': '9bccf863ce574484a95424df960c1470',
  'EVENT_SETUP.FLIGHTS': '9bccf863ce574484a95424df960c1470',
  'EVENT_SETUP.HANDICAPS': '9bccf863ce574484a95424df960c1470',
  'EVENT_SETUP.HANDICAP_RANGE': '9bccf863ce574484a95424df960c1470',
  'INVITE_PLAYERS.ADD_PLAYERS_GROUPS': '9bccf863ce574484a95424df960c1470',
  'INVITE_PLAYERS.INVITE_TO_EVENT': '9bccf863ce574484a95424df960c1470',
  'INVITE_PLAYERS.PLAYERS_FIELD': '9bccf863ce574484a95424df960c1470',
  'NOTIFICATION.SEND': '9bccf863ce574484a95424df960c1470',
  'OFFICERS_ADMINS.DESCRIPTION': '9bccf863ce574484a95424df960c1470',
  'PLAYER_GROUPS.GROUPS': '9bccf863ce574484a95424df960c1470',
  'POLICIES.TITLE': '9bccf863ce574484a95424df960c1470',
  'REVIEW_SCORES.LEADERBOARD': '9bccf863ce574484a95424df960c1470',
  'ROUND_BASICS.CONTESTS': '9bccf863ce574484a95424df960c1470',
  'ROUND_BASICS.COURSE': '9bccf863ce574484a95424df960c1470',
  'ROUND_BASICS.DATE': '9bccf863ce574484a95424df960c1470',
  'ROUND_BASICS.HOLES': '9bccf863ce574484a95424df960c1470',
  'ROUND_BASICS.SHOTGUN_START': '9bccf863ce574484a95424df960c1470',
  'ROUND_BASICS.START_TIME': '9bccf863ce574484a95424df960c1470',
  'ROUND_BASICS.TEEBOX_ASSIGNMENTS': '9bccf863ce574484a95424df960c1470',
  'ROUND_BASICS.TEE_SHEET_SETUP': '9bccf863ce574484a95424df960c1470',
  'ROUND_DETAILS.GAME_FORMAT': '9bccf863ce574484a95424df960c1470',
  'ROUND_HANDICAPS.TITLE': '9bccf863ce574484a95424df960c1470',
  'ROUND_TEAMS.INVALID_TEAM': '9bccf863ce574484a95424df960c1470'
};

export type TVideoTutorialsSectionsMap = keyof typeof TooltipsLoomIds;
